// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@guestsupply/App/Components/HotspotProduct/HotspotProduct";
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { css } from "styled-components";

styles.wrapper = {
    css: css`
        display: flex;
    `,
};
styles.spinnerWrapper = {
    css: css`
        height: 50px;
        display: flex;
        align-items: center;
    `,
};
styles.productImage = {
    linkWrappingImage: {
        css: css`
            margin-right: 12px;
            align-items: flex-start;
            width: 91px;
            max-height: 91px;
        `,
    },
    img: {
        css: css`
            height: 91px;
            width: 91px;
        `,
    },
};
styles.descriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
    `,
};
styles.productDescription = {
    ...createProductDescriptionStyles({
        productDetailLink: {
            typographyProps: {
                size: 12,
                css: css`
                    line-height: 13px;
                `,
            },
            css: css`
                min-height: unset;
            `,
        },
        productDetailDescription: {
            css: css`
                min-height: unset;
            `,
        },
    }),
};
styles.partNumberStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-bottom: 23px;
                align-items: baseline;
            `,
        },
        heading: {
            css: css`
                line-height: 13px;
            `,
        },
        text: {
            weight: 400,
        },
    }),
};
styles.productPrice = {
    wrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    price: {
        priceText: {
            size: "18px",
            lineHeight: "22px",
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: "13px",
                lineHeight: "20px",
                weight: 400,
            },
        },
    },
};
styles.productActionsStyle = {
    addToCartContainer: {
        css: css`
            column-gap: 13px;
        `,
    },
    productQuantityOrderedStyles: {
        qtyFieldStyles: {
            editableQuantityTextField: {
                cssOverrides: {
                    inputSelect: css`
                        max-width: 55px;
                    `,
                },
            },
        },
    },
};
styles.notify = {
    css: css`
        margin-bottom: 0;
    `,
};
